import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EditProfileSideMenu.css';
import { Col } from 'react-bootstrap';
import cx from 'classnames';

// Component
import Link from '../Link';

// Locale
import messages from '../../locale/messages';

// Redux
import { connect } from 'react-redux';
import { Text } from '../../components_new/common';
import Button from '../../components_new/common/FormComponents/Button';

const topSpace = '8px';
class EditProfileSideMenu extends React.Component {
  render() {
    const { userData } = this.props;
    let isVerified;
    if (userData) {
      isVerified = userData.profileId;
    }

    return (
      <div>
        <ul className={s.listContainer}>
          <li>
            <Link to={'/user/edit'}>
              <Text link large helvetica mb={topSpace}>
                <FormattedMessage {...messages.editProfile} />
              </Text>
            </Link>
          </li>
          <li>
            <Link to={'/user/photo'}>
              <Text link large helvetica mb={topSpace}>
                <FormattedMessage {...messages.profilePhoto} />
              </Text>
            </Link>
          </li>
          <li>
            <Link to={'/user/verification'}>
              <Text link large helvetica mb={topSpace}>
                <FormattedMessage {...messages.trustAndVerification} />
              </Text>
            </Link>
          </li>
          <li>
            <Link to={'/user/reviews'}>
              <Text link large helvetica mb={topSpace}>
                <FormattedMessage {...messages.reviews} />
              </Text>
            </Link>
          </li>
        </ul>
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={cx(s.noPadding, s.space3, s.spaceTop2)}
        >
          <Link to={`/users/show/${isVerified}`}>
            <Button secondary muted mb={topSpace}>
              <FormattedMessage {...messages.viewProfile} />
            </Button>
          </Link>
        </Col>
      </div>
    );
  }
}

const mapState = state => ({
  userData: state.account.data,
});

const mapDispatch = {};

export default injectIntl(
  withStyles(s)(
    connect(
      mapState,
      mapDispatch,
    )(EditProfileSideMenu),
  ),
);



// WEBPACK FOOTER //
// ./src/components/EditProfileSideMenu/EditProfileSideMenu.js